export enum ProviderNetworkTypeEnum {
  Unknown = "unknown",
  Network = "network",
  Prospect = "prospect",
  Market = "market",
  NetNew = "netNew",
  NextClosestProviders = "nextClosestProvider",
}

// Standardized display order for provider source chips, enforced across all Provider Hub views.
export const providerNetworkTypeDisplayOrder: ProviderNetworkTypeEnum[] = [
  ProviderNetworkTypeEnum.Network,
  ProviderNetworkTypeEnum.Prospect,
  ProviderNetworkTypeEnum.Market,
  ProviderNetworkTypeEnum.NetNew,
];

// Provider network types treated as out-of-network, enforced across all Provider Hub views.
export const outOfNetworkProviderNetworkTypes: readonly ProviderNetworkTypeEnum[] = [
  ProviderNetworkTypeEnum.Prospect,
  ProviderNetworkTypeEnum.Market,
  ProviderNetworkTypeEnum.NetNew,
];

// Returns a new array of provider network types ordered by the standardized display order.
// Types not present in the order list (e.g. Unknown, NextClosestProviders) are placed at the end.
export const sortProviderNetworkTypes = (types: ProviderNetworkTypeEnum[]): ProviderNetworkTypeEnum[] => {
  const orderIndex = (type: ProviderNetworkTypeEnum): number => {
    const index = providerNetworkTypeDisplayOrder.indexOf(type);
    return index === -1 ? providerNetworkTypeDisplayOrder.length : index;
  };

  return [...types].sort((a, b) => orderIndex(a) - orderIndex(b));
};
